<!--embed src="../../mw/assets/Support/Support doc - Registration OneID Portal.pdf" width="100%" height="900px"/-->
<!--embed src="../../mw/assets/Support/Support doc - Registration OneID Portal.pdf" style="width:100vw;height:100vh;"/-->
<header>
    <div class="container">
        <div class="logos">
          <a>
            <img src="../../mw/assets/img/dubai-gov-logo.png" />
          </a>
          <a>        
            <img src="../../mw/assets/img/emirates-logo.png" />
          </a>
          <a>
            <img src="../../mw/assets/img/dewa-logo.png" />
          </a>
        </div>
      </div>
  </header>

  <div class="container" style="overflow:auto;max-height: calc(100vh - 100px);">
    <div class="row justify-content-left align-margin">
        <img src="../../mw/assets/img/Group.png" style="height:20px;padding-top:5px;"/>
        &nbsp;&nbsp;<a routerLink="/login" style="font-size:18px;vertical-align:middle;color:#087b36">Back to Login</a>
    </div>

    <div class="row justify-content-left align-margin">
      <span style="font-size:18px" class="text-lightdark">OneID Portal</span>
  </div>

    <div class="row justify-content-left align-margin">                    
                    <h4 style="margin-bottom:20px">
                      Terms & Conditions
                    </h4>
    </div>
                  <div class="row justify-content-left align-margin">
                    <!--p-->
                    <!--div class="col-md-8 offset-md-2"-->
                    <div>
                      <h6>Terms and Conditions of Use of this website </h6>
                      <p>Your access to and use of the Dubai Electricity and Water Authority’s (DEWA’s) website (the ‘Site’) is subject to the following terms and conditions, as well as UAE laws. Your access to the Site is in consideration for your agreement to these Terms and Conditions of Use, whether or not you are a registered user. By accessing, browsing, and using the Site, you accept, without limitation or qualification, these Terms and Conditions of Use.
                      </p>
                      
                      <h6>Modification of Terms and Conditions </h6>
                      <p>DEWA maintains the right to modify these Terms and Conditions of Use. The modified terms and conditions will be published on this page. Any modification is effective immediately upon posting. Your use of the Site following the posting of any modification signifies your acceptance of such modification. You should periodically visit this page to review the current 'Terms and Conditions of Use'.
                      </p> 

                      <h6>Conduct </h6>
                      <p>You agree to access and use the Site only for lawful purposes. You are solely responsible for the knowledge of and adherence to any and all laws, statutes, rules and regulations pertaining to your use of the Site. By accessing the Site, you agree that you will not: </p>
                        <ol>
                    <li>
                        Use the Site to commit a criminal offense or to encourage others to engage in any conduct which would constitute a criminal offense or give rise to civil liability;
                    </li>
                    <li>
                        Post or transmit any discriminatory, libellous, harassing, defamatory, obscene, pornographic, or otherwise unlawful content;
                    </li>
                    <li>
                        Use the Site to impersonate other parties or entities;
                    </li>
                    <li>
                        Use the Site to upload any content that contains a software virus, "Trojan Horse" or any other computer code, files, or programs that may alter, damage, or interrupt the functionality of the Site or the hardware or software of any other person who accesses the Site;
                    </li>
                    <li>
                        Upload, post, email, or otherwise transmit any materials that you do not have a right to transmit under any law or under a contractual relationship;
                    </li>
                    <li>
                        Alter, damage, or delete any content posted on the site;
                    </li>
                    <li>
                        Disrupt the normal flow of communications in any way;
                        </li>
                        <li>
                        Claim a relationship with or represent any business, association, or other organization with which you are not authorized to claim such a relationship or represent;
                        </li>
                        <li>
                        Post or transmit any unsolicited advertising, promotional materials, or other forms of solicitation;
                        </li>
                        <li>
                        Post any material that infringes upon or violates the intellectual property rights of another; or
                        </li>
                        <li>
                        Collect or store personal information about others.
                        </li></ol>                    
                      <h6>Registration </h6>                      
                      <p>DEWA may, in its sole discretion, terminate or suspend your access to and use of this Site without notice and for any reason, including for violation of these Terms and Conditions of Use or for other conduct which DEWA, in its sole discretion, believes is unlawful or harmful to others. In the event of termination, you will no longer be authorised to access the Site, and DEWA will use any means possible to enforce this termination.
                      </p> 

                      <h6>Termination of Use </h6>                      
                      <p>Your access to and use of the Dubai Electricity and Water Authority’s (DEWA’s) website (the ‘Site’) is subject to the following terms and conditions, as well as UAE laws. Your access to the Site is in consideration for your agreement to these Terms and Conditions of Use, whether or not you are a registered user. By accessing, browsing, and using the Site, you accept, without limitation or qualification, these Terms and Conditions of Use.
                      </p> 

                      <h6>Other Site Links </h6>                      
                      <p>Some links on the Site lead to websites that are not operated by Dubai Electricity and Water Authority. DEWA does not control these websites nor do we review or control their content. DEWA provides these links to users for convenience. These links are not an endorsement of products, services, or information, and do not imply an association between DEWA and the operators of the linked website. When you select a link to an outside website, you are subject to the terms and conditions of the owner/sponsors of that outside website.
                      </p> 
                      
                      <h6>Content </h6>                      
                      <p>DEWA reserve the right to monitor any content that you provide, but shall not be obligated to do so. Although DEWA cannot monitor all postings on the Site, we reserve the right (but assume no obligation) to delete, move, or edit any postings that violate these terms and conditions. The UAE and foreign copyright laws and international conventions protect the contents of the Site. You agree to abide by all copyright notices posted on the Site.
                      </p> 
                      
                      <h6>Indemnity </h6>                      
                      <p>You agree to defend, indemnify, and hold harmless DEWA and all of its employees and agents from any and all liabilities incurred in connection with any claim arising from any breach by you of these Terms and Conditions of Use, including reasonable attorneys' fees and costs. You agree to cooperate fully in the defense of any such claim. DEWA reserves the right to assume, at its own expense, the exclusive defence and control of any matter otherwise subject to indemnification by you. You agree not to settle any matter without the written consent of Dubai Electricity and Water Authority.
                      </p> 
                      
                      <h6>Disclaimer of Warranty </h6>
                      <p>You expressly understand and agree that your use of the Site, or any material available through this Site, is at your own risk. Neither DEWA nor its employees warrant that the Site will be uninterrupted, problem-free, free of omissions, or error-free; nor do they make any warranty as to the results that may be obtained from the use of the Site. The content and function of the Site are provided to you "as is," without warranties of any kind, either express or implied, including, but not limited to, warranties of title, merchantability, fitness for a particular purpose or use, or currency.
                      </p> 

                      <h6>Limitation of Liability </h6>
                      <p>In no event will DEWA or its employees be liable for any incidental, indirect, special, punitive, exemplary, or consequential damages, arising out of your use of or inability to use the Site, including without limitation, loss of revenue or anticipated profits, loss of goodwill, loss of business, loss of data, computer failure or malfunction, or any other damages. 
                      </p>

                      <table style="width:100%;">
                          <tr>
                        <td style="width:90%">
                      <p style="font-size:11px">
                        &copy; 2021 Dubai Electricity and Water Authority. All Rights Reserved. The site is best viewed using IE 11 and above, Mozilla Firefox, Safari and Chrome.
                      </p></td>
                      <!--td><p style="font-size:11px">Version 1.0</p></td-->
                          </tr></table>   
                          
                        </div>                   
    </div>

    <!---- Footer---------->
        <!--div class="row maincontent"-->
          <!--div class="col-auto"-->
          <!--p class="pull-left">
            &copy; 2021 Dubai Electricity and Water Authority. All Rights Reserved. The site is best viewed using IE 11 and above, Mozilla Firefox, Safari and Chrome.
          </p-->
        <!--/div-->
        <!--div class="col"-->
          <!--p class="pull-right">
            version1.0
          </p-->
        <!--/div-->
      <!--/div-->            
  </div>
    <!--footer1-->
        <!--div class="row"-->
          <!--div class="col-auto"-->
            <!--p class="pull-left" style="margin-top:-20px">
              &copy; 2021 Dubai Electricity and Water Authority. All Rights Reserved. The site is best viewed using IE 11 and above, Mozilla Firefox, Safari and Chrome.
            </p-->
          <!--/div-->
          <!--div class="col"-->
            <!--p class="pull-right" style="margin-top:-20px">
              version1.0
            </p-->
          <!--/div-->
        <!--/div-->      
        <!--div class="clearfix"></div-->
      <!--/footer1-->  